export enum RecordingTypeKeys {
    ENACT_RECORDING = 'recording/ENACT_RECORDING',
    SET_RECORDER_INTERVAL_ID = 'recording/SET_RECORDER_INTERVAL_ID',
    INCREMENT_RECORDED_TIME = 'recording/INCREMENT_RECORDED_TIME',
    INITIATE_TRANSCODING_OF_RECORDED_AUDIO = 'recording/INITIATE_TRANSCODING_OF_RECORDED_AUDIO',
    SAVE_RECORDED_AUDIO = 'recording/SAVE_RECORDED_AUDIO',
    SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_WORKSPACE = 'recording/SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_WORKSPACE',
    SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_PARTY = 'recording/SAVE_RECORDED_AUDIO_BUT_WAIT_FOR_PARTY',
    SAVE_RECORDED_AUDIO_SUCCESS = 'recording/SAVE_RECORDED_SUCCESS',
    SAVE_RECORDED_AUDIO_FAILED = 'recording/SAVE_RECORDED_FAILED',
    REJECT_RECORDING_PERMISSION = 'recording/REJECT_RECORDING_PERMISSION',
    GRANT_RECORDING_PERMISSION = 'recording/GRANT_RECORDING_PERMISSION',
    PAUSE_RECORDING = 'recording/PAUSE_RECORDING',
    RESUME_RECORDING = 'recording/RESUME_RECORDING',
    SET_WORKSPACE_RESTORED = 'recording/SET_WORKSPACE_RESTORED',
    ASK_CANCEL_RECORDING = 'recording/ASK_CANCEL_RECORDING',
    CANCEL_RECORDING = 'recording/CANCEL_RECORDING',
    DESIST_CANCEL_RECORDING = 'recording/DESIST_CANCEL_RECORDING',
    CLOSE_RECORDING = 'recording/CLOSE_RECORDING',
    ASK_REDO_RECORDING = 'recording/ASK_REDO_RECORDING',
    REDO_RECORDING = 'recording/REDO_RECORDING',
    DESIST_REDO_RECORDING = 'recording/DESIST_REDO_RECORDING',
    REENACT_RECORDING = 'recording/REENACT_RECORDING',
    ASK_FILENAME_FOR_RECORDING = 'recording/ASK_FILENAME_FOR_RECORDING',
    SET_FILENAME = 'recording/SET_FILENAME',
    RETRY_SAVING = 'recording/RETRY_SAVING',
}

export enum RecorderStatus {
    UNINITIALIZED = 'uninitialized',
    RECORDING = 'recording',
    SAVING = 'saving',
    SAVING_WAITING_FOR_WORKSPACE = 'saving_waiting_for_workspace',
    SAVING_WAITING_FOR_PARTY = 'saving_waiting_for_party',
    PAUSED = 'paused',
    SAVING_FAILED = 'saving_failed',
    AWAITING_CANCEL_CONFIRMATION = 'awaiting_cancel_confirmation',
    AWAITING_REDO_CONFIRMATION = 'awaiting_redo_confirmation',
    AWAITING_FILENAME = 'awaiting_filename',
    AWAITING_FILENAME_AND_WORKSPACE = 'awaiting_filename_and_workspace',
    RECORDING_CANCELLED = 'recording_cancelled',
    PENDING_REDO = 'pending_redo',
}

export enum ModuleStatus {
    UNINITIALIZED = 'uninitialized',
    AWAITING_MIC_PERMISSION = 'awaiting_mic_permission',
    RECORDING = 'recording',
    STOPPED = 'stopped',
    BLOCKED = 'blocked',
    PAUSED = 'paused',
}

export type PartyContextValues = {
    partyName?: string;
    partyId?: number;
};

export type RecordedAudioValues = {
    filename: string;
    recordedBlob?: any;
};

export type RecordingContextValues = {
    partyState?: PartyContextValues;
    commentId?: number;
    workspaceId?: string;
    questionId?: number;
    assessmentRunId?: number;
    featureId: string;
};

export type TranscodedInfo = {
    recordedAudio: RecordedAudioValues;
    shouldWaitForWorkspace: boolean;
};
